export default __webpack_public_path__ + "static/media/3s.40b6f7d4.jpg";